module.exports = __webpack_public_path__ + "img/p3_r.8d86c12a.jpg";